import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuardWithForcedLogin } from "src/app/core/auth/auth-guard-with-forced-login.service";
import { HSPAPermission } from "src/app/shared/models/hspa-permission.enum";
import { ClinicalComponent } from "./clinical.component";
import { PatientDetailComponent } from "./patient-detail/patient-detail.component";

const routes: Routes = [
    {
        path: '',
        canActivate: [AuthGuardWithForcedLogin],
        data: { expectedPermissions: HSPAPermission.ViewClinician },
        component: ClinicalComponent
    },
    {
        path: 'clinician/patient-device-detail',
        canActivate: [AuthGuardWithForcedLogin],
        component: PatientDetailComponent
      },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ClinicalRoutingModule { }
